module.exports = __webpack_public_path__ + "img/manufacture.b10d459.jpg";